import React, { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ConsumerVoiceTool } from '../../components/ConsumerVoice/ConsumerVoiceTool';
import { PAGE_BG } from '../../components/ProposalFlow/theme';
import { useUser } from '../../hooks/useUser';

// Public /consumer-voice-audit page — the anonymous / sales-facing Consumer
// Voice tool: captcha + email when logged out (lead capture), no captcha or
// email for a signed-in session, ?bg= embed override like /pdp-audit.
function parseBgParam(raw: string | null): string {
  if (!raw) return PAGE_BG;
  const cleaned = raw.replace(/^#/, '').trim();
  if (/^[0-9a-fA-F]{3}$/.test(cleaned) || /^[0-9a-fA-F]{6}$/.test(cleaned)) return `#${cleaned}`;
  return PAGE_BG;
}

export default function ConsumerVoicePage() {
  const [searchParams] = useSearchParams();
  const { user } = useUser();
  const isLoggedIn = !!user;
  const bgColor = useMemo(() => parseBgParam(searchParams.get('bg')), [searchParams]);

  useEffect(() => {
    document.body.classList.add('pdp-audit-embed');
    return () => {
      document.body.classList.remove('pdp-audit-embed');
    };
  }, []);

  return (
    <ConsumerVoiceTool
      showCaptcha={!isLoggedIn}
      requireEmail={!isLoggedIn}
      showPortalCta={!isLoggedIn}
      bgColor={bgColor}
      strategyPath="/proposal"
    />
  );
}
